import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full" data-id="element-72">
      <div className="max-w-3xl mx-auto px-4 pt-10 pb-6" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} data-id="element-74">
          <p className="text-sm uppercase tracking-widest mb-4" style={{
          color: 'var(--color-brown)'
        }} data-id="element-75">
            Persönliche Erfahrung
          </p>
          <h2 className="text-2xl md:text-4xl leading-snug md:leading-tight font-semibold mb-6" style={{
          color: 'var(--color-text)'
        }} data-id="element-76">
            Mein Hund hatte ständig Magenprobleme – bis ich diese eine Sache
            entdeckt habe
          </h2>
          <p className="text-base md:text-lg leading-relaxed" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-77">
            Eine Geschichte über schlaflose Nächte, unzählige Tierarztbesuche
            und die Lösung, die alles verändert hat.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="max-w-3xl mx-auto px-4 pb-10" data-id="element-78">
        <div className="rounded-2xl overflow-hidden shadow-md" data-id="element-79">
          <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=900&h=500&fit=crop&crop=faces" alt="Oscar, ein Labrador Mischling, liegt entspannt auf einer Wiese" className="w-full h-64 md:h-96 object-cover" data-id="element-80" />
        </div>
        <p className="text-xs text-center mt-2 italic" style={{
        color: 'var(--color-text-light)'
      }} data-id="element-81">
          Mein Oscar – heute endlich wieder glücklich und voller Energie
        </p>
      </motion.div>
    </section>;
}